export const appies = [
  {
    img: "https://desktime.com/assets/img/new-homepage/desktop/desktop.webp",
    headText: "DeskTime for desktops",
    title: "Requires download and installation",
    line1: "Fully automated time tracker",
    line2: "App, URL & Document title tracking",
    line3: "Project and task tracking",
    line4: "Screenshots",
    line5: "Idle and Private time",
  },
  {
    img: "https://desktime.com/assets/img/new-homepage/mobile/mobile.webp",
    headText: "DeskTime for mobile phones",
    title: "Requires download and installation",
    line1: "Manual time tracker",
    line2: "Workday overview",
    line3: "Project and task tracking",
  },
  {
    img: "https://desktime.com/assets/img/new-homepage/webtimer/webtimer.webp",
    headText: "Manual time tracking",
    title: "No software installation necessary",
    line1: "Manual time tracker",
    line2: "Workday overview",
    line3: "Project and task tracking",
  },
];
